
import { useAdminStrategies } from "@/hooks/admin/useAdminStrategies";
import { useAdminProviders } from "@/hooks/admin/useAdminProviders";

export const useStrategyProviderManagement = (providerId: string | null) => {
  // Strategies management
  const { 
    strategies, 
    loading: strategiesLoading, 
    loadStrategies, 
    createStrategy,
    updateStrategy,
    deleteStrategy,
    toggleStrategyStatus,
    toggleStrategyActive,
    approveStrategy 
  } = useAdminStrategies(providerId);
  
  // Providers management
  const {
    providers,
    loading: providersLoading,
    loadProviders,
    createProvider,
    updateProvider,
    deleteProvider,
    toggleProviderActive,
    assignUserToProvider,
    removeUserFromProvider
  } = useAdminProviders();

  return {
    // Strategies related
    strategies,
    strategiesLoading,
    loadStrategies,
    createStrategy,
    updateStrategy,
    deleteStrategy,
    toggleStrategyStatus,
    toggleStrategyActive,
    approveStrategy,
    
    // Providers related
    providers,
    providersLoading,
    loadProviders,
    createProvider,
    updateProvider,
    deleteProvider,
    toggleProviderActive,
    assignUserToProvider,
    removeUserFromProvider
  };
};
